import { Col, Form, InputGroup, Row, textUtils } from '@valid-eval/shared-react-components';
import { Event } from 'data/features/eventsTypes';
import { useTranslation } from 'react-i18next';

const { humanize } = textUtils;

type DetailsListProps = {
  details: Event['team_details'] | Event['judge_details'];
  title: string;
};

export const DetailsList = ({ details, title }: DetailsListProps) => {
  const { t } = useTranslation();

  return (
    <Row>
      <Col md={12} className="mb-3">
        <h3>{title}</h3>
      </Col>
      {details.map((detail) => (
        <Col key={detail.id} md={6} className="mb-2">
          <Form.Group>
            <Form.Label htmlFor={detail.id}>{detail.title}</Form.Label>
            <InputGroup>
              <Form.Control
                id={detail.id}
                type="text"
                value={humanize(detail.field_type)}
                disabled
                readOnly
              />
              {detail.required && (
                <InputGroup.Text className="text-danger">
                  <small>{t('event.form.required')}</small>
                </InputGroup.Text>
              )}
            </InputGroup>
          </Form.Group>
        </Col>
      ))}
    </Row>
  );
};
